import React from "react";
import Button from "../Button";
import Jumbotron from "../Jumbotron";
import Text from "../Text";

interface Props {
  heading?: string;
  content: string;
  linkUrl?: string;
  tagList?: string[];
  margin?: string;
}

const CardPrimary: React.FC<Props> = ({
  heading,
  content,
  tagList,
  linkUrl,
  margin="20px 0"
}) => (
  <Jumbotron
    flexDirection="column"
    justifyContent="flex-start"
    textAlign="left"
    width="100%"
    margin={margin}
  >
    {heading && (
      <Text
        text={heading}
        fs="26px"
        fontWeight="400"
        linkUrl={linkUrl}
        clickAble
      />
    )}
    <Text
      text={content}
      fs="16px"
      color="#666"
      fontWeight="300"
      margin="10px 2px"
    />

    <Jumbotron justifyContent="flex-start" width="100%">
      {tagList &&
        tagList.map((tag) => (
          <Button
            bg="gray"
            margin="10px 10px 0 0"
            key={heading+tag}
            fontSize="11px"
            padding="2px 5px"

            text={tag}
            height="20px"
            flexGrow="unset"
            handleOnClick={() => console.log("Now Smile")}
          />
        ))}
    </Jumbotron>
  </Jumbotron>
);

export default CardPrimary;
